import { render, staticRenderFns } from "./SelectMotifComponent.vue?vue&type=template&id=3795865d"
import script from "./SelectMotifComponent.vue?vue&type=script&lang=js"
export * from "./SelectMotifComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports